module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <h4>Refund Shipment</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> </section> <section class=\"modal-body\"> <p>Are you sure you want to refund the following shipment?</p> <dl> <dt>Shipment ID:</dt> <dd><code>")
    ; __append(escapeFn( locals.id ))
    ; __append("</code></dd> <dt>Tracking code:</dt> <dd><code>")
    ; __append(escapeFn( locals.tracking_code ))
    ; __append("</code></dd> </dl> </section> <section class=\"modal-footer\"> <button class=\"btn btn-clear cancel\" type=\"button\">Cancel</button> <button class=\"btn btn-danger submit_refund\" type=\"button\">Refund</button> </section> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/shipment_refund_modal.ejs
// module id = 1699
// module chunks = 1